import React from 'react'
import ReactDOM from 'react-dom'
import './Components/PocketHitsCta';
import './Components/PocketHitsPreferences';
import PocketHits from './Components/PocketHitsCta'
import '../Components/Doyle';
import '../Components/Graphik';
import PocketHitsPreferences from './Components/PocketHitsPreferences'
import PocketHitsConfirmationLanding from './Components/PocketHitsPreferences/PocketHitsConfirmationLanding'

const apps = [
  {
    id: 'pocket-hits-container',
    element: <PocketHits />
  },
  {
    id: 'newsletter-preferences',
    element: <PocketHitsPreferences />
  },
  {
    id: 'newsletter-unsubscribe',
    element: <PocketHitsPreferences />
  },
  {
    id: 'newsletter-confirm',
    element: <PocketHitsConfirmationLanding />
  },
];

document.addEventListener('DOMContentLoaded', () => {
  apps.forEach(({id, element}) => {
    const el = document.getElementById(id);

    if (el) {
      ReactDOM.render(element, el)
    }
  })
});
